import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';

const Checkbox = (props) => {
  const { field, value } = props;
  const { checkboxProps = {}, disabled } = field;

  return (
    <div>
      <AntCheckbox checked={value} disabled={disabled} {...checkboxProps} />
    </div>
  );
};

export default Checkbox;
